<template>
  <div>
    <h3 class="title-func" id="ingredients">
      <LabelFunMessage fcontId="0" msgkey="100" />
    </h3>
    <div class="row">
      <h4 class="prepare">
        &darr;&nbsp;<LabelFunMessage fcontId="0" msgkey="101" />
      </h4>
    </div>

    <div class="row preview">
      <div
        v-for="designID in designPaperList"
        v-bind:key="designID"
        class="col-xs-4 col-sm-2 col-md-2 col-lg-1"
      >
        <a
          v-on:click="clickLink(designID)">
          <img
            v-bind:src="app_root + '/assets/common/img/fun/designpaper/thumnails/' + designID + '.png'"
            class="thumnail-image"
          />
        </a>
      </div>
    </div>
    <a v-on:click="clickAllDPLink()">
      <LabelFunMessage fcontId="0" msgkey="182" />&nbsp;&raquo;
    </a>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { CONTENTS_INFO } from "@/common/contentsinfo";
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "UseDesignPaperList",
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    };
  },
  computed: {
    ...mapState(["os","lg2"]),
    ...mapGetters(["isWwTemplate"]),
    fcontid: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    },
    designPaperList: function () {
      return CONTENTS_INFO[this.fcontid].design_id_list;
    },
    usedMediaSize: function () {
      return CONTENTS_INFO[this.fcontid].media_size;
    },
    usedMediaType: function () {
      return CONTENTS_INFO[this.fcontid].media_type;
    }
  },
  methods: {
    clickLink: function (designID) {
      const param = {
        articleIdToSamplePage: this.fcontid,
        mediaSize: this.usedMediaSize,
        mediaType: this.usedMediaType
      }
      this.$store.commit('setDesignPaperParameters', param)
      
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "designpaper_thumbnail",
        "custom_parameter2": designID
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/designpaper/' + designID,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    },
    clickAllDPLink: function () {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "all_designpaper_link"
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/190#dp_lineup',
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview {
  margin-bottom: 10px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  
}

/* PCサイズのみ適用 */
@media screen and (min-width: 992px) {
  
}
</style>
